import create from "zustand";

import createFormErrorSlices from "../../../../../../utils/store/formErrors";

interface iHeatingOilAgb {
    agbChecked: boolean;
    setAgbChecked: (agbChecked: boolean) => void;
    errors: string[];
}

const useStore = create<iHeatingOilAgb>((set, get) => ({
    ...createFormErrorSlices(set, get),
    agbChecked: false,

    isAgbValid: () => {
        if (get().agbChecked) {
            return true;
        } else {
            set({ errors: ["agb"] });
            return false;
        }
    },

    setAgbChecked: (agbChecked) => {
        set({ agbChecked: agbChecked });
        if (agbChecked) {
            set({ errors: [] });
        }
    },
}));

export default useStore;
